import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can sync data from Bing Ads reports by configuring it as a source in PostHog. These are the supported entity and reports:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Report Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/advertising/guides/campaign-management-guides?view=bingads-13"
            }}>{`Campaigns`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/advertising/guides/reports"
            }}>{`Campaign Performance Report`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Performance metrics at the campaign level`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/advertising/guides/reports"
            }}>{`Ad Group Performance Report`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Performance metrics at the ad group level`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/advertising/guides/reports"
            }}>{`Ad Performance Report`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Performance metrics at the ad level`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Additional reports will be added based on user feedback we receive via our `}<a parentName="p" {...{
        "href": "https://app.posthog.com/#panel=support%3Afeedback%3Adata_warehouse%3Alow%3Atrue"
      }}>{`in-app support form`}</a>{`.`}</p>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`A Bing Ads account with permission to access data from accounts you want to sync.`}</li>
      <li parentName="ul">{`Your account ID from the `}<a parentName="li" {...{
          "href": "https://ui.ads.microsoft.com/"
        }}>{`Bing Ads interface`}</a>{` > `}<strong parentName="li">{`Settings`}</strong>{` > `}<strong parentName="li">{`Account Settings`}</strong>{` > The account ID will be visible below the `}<strong parentName="li">{`Account ID`}</strong>{` header.`}</li>
    </ul>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/q_auto,f_auto/Screenshot_2025_11_20_at_2_31_35_PM_57e3bef9cc.png" classes="rounded" alt="Bing Ads account ID" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "configuring-posthog"
    }}>{`Configuring PostHog`}</h2>
    <p>{`Connect PostHog to your Bing Ads account using a Microsoft account. The Microsoft account must have administrator or standard access to your Bing Ads account to view campaign data and reports.`}</p>
    <ol>
      <li parentName="ol">{`In PostHog, go to the `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://app.posthog.com/pipeline/sources"
          }}>{`Data pipelines`}</a></strong>{` tab.`}</li>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`+ New`}</strong>{` drop-down menu in the top-right and select `}<strong parentName="li">{`Source`}</strong>{`.`}</li>
      <li parentName="ol">{`Find Bing Ads in the sources list and click `}<strong parentName="li">{`Link`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter the `}<strong parentName="li">{`Account ID`}</strong>{` of the Bing Ads account you want to sync.`}</li>
      <li parentName="ol">{`Select an existing Bing Ads account, or create a new integration.`}</li>
      <li parentName="ol">{`(Optional) Add a prefix for the table name.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      